import { AbstractControl, ValidationErrors } from "@angular/forms";

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const hasWhitespace = /\s/.test(control.value || '');
    return hasWhitespace ? { whitespace: true } : null;
}

export function mustContainLetterValidator(control: AbstractControl): ValidationErrors | null {
    const hasLetter = /[a-zA-Z]/.test(control.value || '');
    return hasLetter ? null : { noLetter: true };
}